import React from 'react'
import LoginComponent from '../Components/Login/Login'

function Login() {
    return (
        <LoginComponent />
    )
}

export default Login
